import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { APP_NAME, IS_APP_PRODUCTION } from "../constants/app";

const characterList = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const CookieList = ["accessToken", "refreshToken"];

export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;

export function getCurrentUrl(location) {
  return location.pathname.split(/[?#]/)[0];
}
export function checkIsActive(location, url) {
  const current = getCurrentUrl(location);
  const currentSplit = current.split("/");

  if (!current || !url) {
    return false;
  }

  if (current === url) {
    return true;
  }

  if (url.split("/").every((urlPiece) => currentSplit.includes(urlPiece))) {
    return true;
  }

  return false;
}

export const endOf = (type, date = new Date()) => {
  let result;
  switch (type) {
    case "day":
      result = new Date();
      break;
    case "week":
      let day = date.getDay();
      result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (day === 0 ? 0 : 7) - day);
      break;
    case "month":
      result = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      break;
    case "year":
      result = new Date(date.getFullYear(), 11, 31);
      break;
    default:
      result = date;
  }
  return result;
};

export const startOf = (type, date = new Date()) => {
  let result;
  switch (type) {
    case "day":
      result = new Date();
      break;
    case "week":
      let day = date.getDay();
      result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (day === 0 ? -6 : 1) - day);
      break;
    case "month":
      result = new Date(date.getFullYear(), date.getMonth(), 1);
      break;
    case "year":
      result = new Date(date.getFullYear(), 0, 1);
      break;
    default:
      result = date;
  }
  return result;
};

export function generateCookiesName() {
  let secretCode = 10;
  for (let i = 0; i < APP_NAME.length; i++) {
    secretCode += APP_NAME.charCodeAt(i) * APP_NAME.length;
  }

  secretCode = Math.round(secretCode / APP_NAME.length);
  let GeneratedCookiesName = {};
  CookieList.forEach((cookie) => {
    let tempCookieString = "";
    for (let j = 0; j < cookie.length; j++) {
      let charCode = Math.floor((cookie.charCodeAt(j) * characterList.length * cookie.length) / secretCode);
      charCode = charCode > characterList.length ? charCode - characterList.length : charCode;
      tempCookieString += characterList.charAt(Math.floor(charCode));
    }

    GeneratedCookiesName[cookie] = tempCookieString;
  });
  return GeneratedCookiesName;
}
export function generatePredictableUniqueKeyName(key) {
  let secretCode = 10;
  for (let i = 0; i < APP_NAME.length; i++) {
    secretCode += APP_NAME.charCodeAt(i) * APP_NAME.length;
  }

  secretCode = Math.round(secretCode / APP_NAME.length);
  let uniqueKeyString = "";
  for (let j = 0; j < key.length; j++) {
    let charCode = Math.floor((key.charCodeAt(j) * characterList.length * key.length) / secretCode);
    charCode = charCode > characterList.length ? charCode - characterList.length : charCode;
    uniqueKeyString += characterList.charAt(Math.floor(charCode));
  }
  return uniqueKeyString;
}
export const generatedCookies = generateCookiesName();
export const storage = IS_APP_PRODUCTION
  ? {
      getToken: () => Cookies.get(generatedCookies.accessToken) && CryptoJS.AES.decrypt(Cookies.get(generatedCookies.accessToken), APP_NAME).toString(CryptoJS.enc.Utf8),
      setToken: (token) => Cookies.set(generatedCookies.accessToken, CryptoJS.AES.encrypt(token, APP_NAME).toString(), { secure: true, path: IS_APP_PRODUCTION ? `/` : `/${APP_NAME}`, expires: 0.5 }),
      clearToken: () => Cookies.remove(generatedCookies.accessToken, { path: IS_APP_PRODUCTION ? `/` : `/${APP_NAME}` }),
      setSessionStorage: (key, value) => window.sessionStorage.setItem(generatePredictableUniqueKeyName(key), JSON.stringify(value)),
      getSessionStorage: (key) => window.sessionStorage.getItem(generatePredictableUniqueKeyName(key)) && JSON.parse(window.sessionStorage.getItem(generatePredictableUniqueKeyName(key))),
    }
  : {
      getToken: () => window.localStorage.getItem(generatedCookies.accessToken) && CryptoJS.AES.decrypt(window.localStorage.getItem(generatedCookies.accessToken), APP_NAME).toString(CryptoJS.enc.Utf8),
      setToken: (token) => window.localStorage.setItem(generatedCookies.accessToken, CryptoJS.AES.encrypt(token, APP_NAME).toString()),
      clearToken: () => window.localStorage.removeItem(generatedCookies.accessToken),
      setSessionStorage: (key, value) => window.sessionStorage.setItem(generatePredictableUniqueKeyName(key), JSON.stringify(value)),
      getSessionStorage: (key) => window.sessionStorage.getItem(generatePredictableUniqueKeyName(key)) && JSON.parse(window.sessionStorage.getItem(generatePredictableUniqueKeyName(key))),
    };
export const toCapitalize = (word = "") => {
  return word[0].toUpperCase() + word.slice(1).toLowerCase();
};

export const toCamelize = (str) => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
};

export const formatToCurrency = (num) => {
  let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",

    //These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
  return formatter.format(num);
};
export const formatToKHCurrency = (num) =>
  new Intl.NumberFormat("km-KH", {
    style: "currency",
    currency: "KHR",
  }).format(num);

export const parseToNumber = (stringNumber, locale = "en-US") => {
  let thousandSeparator = Intl.NumberFormat(locale)
    .format(11111)
    .replace(/\p{Number}/gu, "");
  let decimalSeparator = Intl.NumberFormat(locale)
    .format(1.1)
    .replace(/\p{Number}/gu, "");

  return parseFloat(
    stringNumber
      .substring(1)
      .replace(new RegExp("\\" + thousandSeparator, "g"), "")
      .replace(new RegExp("\\" + decimalSeparator), "."),
  );
};

export const toastGenerator = ({ payrollConfirmAlert = false, status = "success", message = "" }) => {
  const toastTitle = {
    success: () => `Information`,
    warning: () => `Information`,
    error: () => `Something went wrong`,
  };
  const toastDescription = {
    success: () => (message ? message : `Data has been saved.`),
    warning: () => (message ? message : `Unable to save data.`),
    error: () => `Please try again.`,
  };

  return {
    title: toastTitle[status](),
    description: toastDescription[status](),
    fontSize: "sm",
    status: status,
    variant: "subtle",
    duration: payrollConfirmAlert ? 80000 : 2000,
    position: "top",
    isClosable: true,
  };
};

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export const isValidDate = (value) => {
  return value && value instanceof Date && !isNaN(value) ? value : null;
};

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export function exportTableToExcel(tableID, filename = "") {
  var downloadLink;
  var dataType = "data:text/csv;charset=utf-8,%EF%BB%BF";
  var tableSelect = document.getElementById(tableID);
  var tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");

  // Specify file name
  filename = filename ? filename + ".xls" : "excel_data.xls";

  // Create download link element
  downloadLink = document.createElement("a");

  document.body.appendChild(downloadLink);

  if (navigator.msSaveOrOpenBlob) {
    var blob = new Blob(["\ufeff", tableHTML], {
      type: dataType,
    });
    navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // Create a link to the file
    downloadLink.href = "data:" + dataType + ", " + tableHTML;

    // Setting the file name
    downloadLink.download = filename;

    //triggering the function
    downloadLink.click();
  }
}

export function shortenSentence(sentence, maxLength = 30) {
  if (sentence?.length > maxLength) {
    return sentence.slice(0, maxLength) + "...";
  }
  return sentence;
}

// * working location helper
export function findPolygonCentroid(pts) {
  var first = pts[0],
    last = pts[pts.length - 1];
  if (first.lat !== last.lat || first.lng !== last.lng) pts.push(first);
  var twicearea = 0,
    lat = 0,
    lng = 0,
    nPts = pts.length,
    p1,
    p2,
    f;
  for (var i = 0, j = nPts - 1; i < nPts; j = i++) {
    p1 = pts[i];
    p2 = pts[j];
    f = (p1.lng - first.lng) * (p2.lat - first.lat) - (p2.lng - first.lng) * (p1.lat - first.lat);
    twicearea += f;
    lat += (p1.lat + p2.lat - 2 * first.lat) * f;
    lng += (p1.lng + p2.lng - 2 * first.lng) * f;
  }
  f = twicearea * 3;
  return { lat: lat / f + first.lat, lng: lng / f + first.lng };
}

// convert minutes to hours
export const convertMinutesToHours = (minutes) => {
	const parsedMinutes = parseFloat(minutes) || 0;
	if (isNaN(parsedMinutes) || parsedMinutes <= 0) return "";
	const hours = Math.floor(parsedMinutes / 60);
	const remainingMinutes = parsedMinutes % 60;
	return hours !== 0 ? `${formatNumber(hours)}hrs ${remainingMinutes}mins` : `${remainingMinutes}mins`;
};

// format number to thousand separator
export function formatNumber(num) {
  if (num == null || num === "" || isNaN(num)) return "";
  const parsedNum = parseFloat(num).toFixed(0);
  const parts = parsedNum.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

// formatTimeString("12:00:00"); // returns "12:00"
export function formatTimeString(timeString) {
	const timePattern = /^\d{2}:\d{2}:\d{2}$/;
	if (!timePattern.test(timeString)) return "";
	// Format the time string to HH:MM
	return timeString.slice(0, 5);
}
export const formatDateKhmer = (date) => {
  const khmerWeekdays = ["អាទិត្យ", "ច័ន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"];
  const khmerMonths = ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"];

  const year = date.getFullYear();
  const month = khmerMonths[date.getMonth()];
  const day = date.getDate();
  const weekday = khmerWeekdays[date.getDay()];
  const hour = date.getHours();
  const minute = date.getMinutes().toString().padStart(2, "0");
  const amPm = hour >= 12 ? "ល្ងាច" : "ព្រឹក";

  const hour12 = hour % 12 || 12;

  return `ថ្ងៃ${weekday} ទី${day} ខែ${month} ឆ្នាំ${year} ${hour12}:${minute} ${amPm}`;
};
